import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { activateScheduleFilter } from '../../../../shared/store/actions';

const Control = ({ filter, isActive, activateScheduleFilter }) => (
  <li className={cx('scope-filter', { active: isActive })}>
    <a
      onClick={(event) => {
        event.preventDefault();
        if (!isActive) {
          activateScheduleFilter(filter);
        }
      }}
      style={{ cursor: 'pointer' }}
      className="filter"
      href={null}
    >
      {filter.label}
    </a>
  </li>
);

export default connect(null, { activateScheduleFilter })(Control);
